import { getStore } from "store";
import me from "models/me";
import hasPermission from "./has-permission";

export function invoicesMenuItemAccess(nextState, replace, callback) {
    const hasAccess = (me.account_type === "brand" && hasPermission("process_payments")) || me.account_type === "buyer";
    if (!hasAccess) {
        replace({ pathname: "/404" });
    }
    callback();
}

export function trackInvoicePageAccess(nextState, replace, callback) {
    /** This code is similar to what we have on payments-frontend client/user-events/index.ts. Update it there too if any changes are required*/
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobile = /iphone|ipad|ipod|android|blackberry|windows phone/g.test(userAgent);
    const isTablet = /(ipad|tablet|playbook|silk)|(android(?!.*mobile))/g.test(userAgent);
    const deviceType = isMobile ? "Mobile" : isTablet ? "Tablet" : "Desktop";

    const { scope } = getStore().getState();
    const data = { brandId: scope?.brand?._id, userType: me.account_type, userAgent: deviceType };
    global.analytics.track("LNAV_INVOICE", data);
    callback();
}
